import cloneDeep from 'lodash/cloneDeep';

export function transformBooleanValuesToString(values, skipClone) {
  const isObjectValue = values && values.constructor === Object;

  let data = isObjectValue ? values : { value: values };
  data = skipClone ? data : cloneDeep(data);

  Object.keys(data).forEach((key) => {
    if (data[key] === true) {
      data[key] = 'true';
    } else if (data[key] === false) {
      data[key] = 'false';
    } else if (data[key]?.constructor === Object) {
      data[key] = transformBooleanValuesToString(data[key], true);
    }
  });

  return isObjectValue ? data : data.value;
}
